import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TimeZone } from 'app/modules/main/models/time-zone';
import { DomainEndpointsService } from 'app/modules/main/services/domain-endpoints.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PublisherTimeZoneService {

  constructor(
    private readonly http: HttpClient,
    private readonly serviceEndpoints: DomainEndpointsService,
  ) {
  }

  public fetch(
    publisherId: number
  ): Observable<TimeZone> {

    return this.performRequest(publisherId);
  }

  private performRequest(
    publisherId: number
  ): Observable<TimeZone> {

    const url = this.serviceEndpoints.publisherTimeZoneUrl
      .replace(':publisherId', String(publisherId));

    return this.http.get<TimeZone>(url);
  }

}
